export default {
  statuses: {
    pending: 'pending',
    running: 'running',
    failed: 'failed',
    completed: 'completed',
    'needs-resync': 'needs-resync'
  }
}
